(function(){
  "use strict";

  function normalizeWhatsAppNumber(raw){
    var digits = String(raw || "").replace(/\D/g, "");
    if(digits.indexOf("0092") === 0) digits = digits.slice(2);
    if(digits.indexOf("03") === 0 && digits.length === 11) digits = "92" + digits.slice(1);
    if(digits.indexOf("3") === 0 && digits.length === 10) digits = "92" + digits;
    return digits;
  }

  function formatDate(value){
    if(!value) return "";
    var parts = value.split("-");
    if(parts.length !== 3) return value;
    return parts[2] + "-" + parts[1] + "-" + parts[0];
  }

  function setMinDates(scope){
    var now = new Date();
    var yyyy = now.getFullYear();
    var mm = String(now.getMonth()+1).padStart(2,"0");
    var dd = String(now.getDate()).padStart(2,"0");
    var min = yyyy + "-" + mm + "-" + dd;
    (scope || document).querySelectorAll('input[type="date"][data-ls-future-date]').forEach(function(el){ el.min = min; });
  }

  function getConfig(form){
    var id = form.getAttribute("data-ls-config-id");
    if(!id) return {};
    var node = document.getElementById(id);
    if(!node) return {};
    try { return JSON.parse(node.textContent || "{}"); } catch(e){ return {}; }
  }

  function showError(form, msg){
    var box = form.querySelector("[data-ls-error]");
    if(!box) return;
    box.textContent = msg;
    box.classList.add("is-visible");
  }

  function clearError(form){
    var box = form.querySelector("[data-ls-error]");
    if(!box) return;
    box.textContent = "";
    box.classList.remove("is-visible");
  }

  function valuesFromForm(form){
    var get = function(name){
      var el = form.querySelector('[name="' + name + '"]');
      return el ? String(el.value || "").trim() : "";
    };
    return {
      kids:get("kids"),
      budget:get("budget"),
      date:formatDate(get("date")),
      city:get("city"),
      package:get("package") || window.LSGoodySelectedPackage || "Not selected — please suggest",
      notes:get("notes") || "None"
    };
  }

  function applyTemplate(template, values){
    var out = String(template || "");
    Object.keys(values).forEach(function(key){
      var token = new RegExp("\\{" + key + "\\}", "g");
      out = out.replace(token, values[key]);
    });
    return out;
  }

  function validate(form, values){
    var missing = [];
    form.querySelectorAll("[data-ls-required]").forEach(function(el){
      if(!String(el.value || "").trim()) missing.push(el.getAttribute("data-ls-label") || el.name || "required field");
    });
    return missing;
  }

  function openWhatsApp(form){
    clearError(form);
    var cfg = getConfig(form);
    var values = valuesFromForm(form);
    var missing = validate(form, values);
    if(missing.length){
      showError(form, (cfg.error_prefix || "Please add: ") + missing.join(", ") + ".");
      return;
    }
    var number = normalizeWhatsAppNumber(cfg.whatsapp_number || "923330699900");
    if(!number){ showError(form,"WhatsApp number is not configured."); return; }
    var message = applyTemplate(cfg.message_template || "", values);
    var url = "https://wa.me/" + number + "?text=" + encodeURIComponent(message);
    window.open(url,"_blank","noopener,noreferrer");
  }

  function initForms(scope){
    (scope || document).querySelectorAll("[data-ls-wa-form]").forEach(function(form){
      if(form.getAttribute("data-ls-ready") === "1") return;
      form.setAttribute("data-ls-ready","1");
      form.addEventListener("submit",function(e){ e.preventDefault(); openWhatsApp(form); });
    });
    setMinDates(scope || document);
  }

  function setPackage(label){
    window.LSGoodySelectedPackage = label;
    document.querySelectorAll('[name="package"]').forEach(function(input){ input.value = label; });
    document.querySelectorAll("[data-ls-selected-package]").forEach(function(display){
      display.textContent = "Selected idea: " + label;
      display.classList.add("is-visible");
    });
  }

  function initPackageButtons(scope){
    (scope || document).querySelectorAll("[data-ls-package-value]").forEach(function(btn){
      if(btn.getAttribute("data-ls-ready") === "1") return;
      btn.setAttribute("data-ls-ready","1");
      btn.addEventListener("click",function(){
        var label = btn.getAttribute("data-ls-package-value") || "";
        setPackage(label);
        var form = document.querySelector("[data-ls-detailed-form]");
        if(form) form.scrollIntoView({behavior:"smooth",block:"start"});
      });
    });
  }

  function initScrollButtons(scope){
    (scope || document).querySelectorAll("[data-ls-scroll-to-form]").forEach(function(btn){
      if(btn.getAttribute("data-ls-ready") === "1") return;
      btn.setAttribute("data-ls-ready","1");
      btn.addEventListener("click",function(e){
        e.preventDefault();
        var form = document.querySelector("[data-ls-detailed-form]");
        if(form) form.scrollIntoView({behavior:"smooth",block:"start"});
      });
    });
  }

  function init(scope){ initForms(scope); initPackageButtons(scope); initScrollButtons(scope); }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded",function(){init(document);}); else init(document);
  document.addEventListener("shopify:section:load",function(e){init(e.target);});
})();
